<template>
  <v-main>
    <OSimpleDialog ref="jsonDialog" :show-buttons="false" title="Debug">
      <pre class="pa-3 maxh-4" style="font-size: 12px">{{ strRow }}</pre>
    </OSimpleDialog>
    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :rememberLastClick="true"
      @rowClicked="showRowDetails"
      :fetcher="fetchData"
    >
      <!-- Customiza a mensagem se não temos CCs selecionados -->
      <template v-slot:when-empty="{ filter, loadStatus }">
        <OJumbo
          info
          v-if="filter.costCenterIds == null || filter.costCenterIds.length < 1"
        >
          Selecione ao menos um Centro de Custo para buscar.
        </OJumbo>

        <OJumbo loading v-else-if="loadStatus == 'not-loaded'">
          Carregando dados...
        </OJumbo>

        <OJumbo question v-else>
          Não foram encontrados dados para o filtro/período informados.
        </OJumbo>
      </template>

      <!-- Customiza o botão de export excel para não exigir
           datas (pois sempre existe o strMonth) mas exigir
           costCenterIds -->
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn icon @click="checkDownload" title="Exportar para Excel">
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { go } from '@/models'
import moment from 'moment'
import { saveBlobAs } from 'oderon-vue/utils'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import OSimpleDialog from 'oderon-vue/cpts/dialogs/OSimpleDialog.vue'

export default {
  pageTitle: 'Medição Multiproduto - CC',
  components: {
    GenericReport,
    OSimpleDialog
  },
  data() {
    return {
      reportSpec: {
        code: 'multiproductCostCenterReport',
        title: 'Medição Multiproduto - CC',

        // apesar de termos um fetcher, esta apiBase é usada
        // para montar o botão de colunas visíveis
        apiBase: '/multiproduct/cost-center',

        filters: [
          {
            type: 'CostCenter',
            whenEmpty: 'Selecione centros de custo...',
            emptyMeansAll: false,
            size: 'sm'
          },
          { type: 'MultiproductPeriod', size: 'sm' },
          {
            prefix: 'format',
            type: 'MultiproductFormat',
            size: 'sm',
            defVal: 'condensed'
          }
        ]
      },

      strRow: null
    }
  },
  methods: {
    showRowDetails({ row }) {
      this.$refs.jsonDialog.$loading(async () => {
        let ps = this.computeApiParams(this.$refs.report.apiParams)
        let fullReport = await go.get('/multiproduct/cost-center', ps)
        let rowData = fullReport.historyRows.find((x) => x.uid == row.id)
        if (rowData == null)
          rowData = fullReport.proRataRows.find((x) => x.uid == row.id)
        this.strRow = JSON.stringify(rowData, null, ' ')
      })
      this.$refs.jsonDialog.open()
    },

    // Retorna os parâmetros para a API, mas não valida os obrigatórios.
    computeApiParams(filter) {
      let { costCenterIds, format, vars } = filter
      if (costCenterIds != null && costCenterIds.length < 1)
        costCenterIds = null

      let thisMonth = moment().format('YYYY-MM')
      let { fromDate, untilDate, strMonth } = filter.multiproductPeriod || {}

      // NB: Não envia limit e offset pois não queremos paginação
      let params = { costCenterIds, format, vars }

      if (fromDate != null) {
        params.fromDate = fromDate
        params.untilDate = untilDate
      } else {
        params.month = strMonth || thisMonth
      }

      return params
    },

    async fetchData(apiParams) {
      const newParams = this.computeApiParams(apiParams)
      if (newParams.costCenterIds == null) {
        return { count: 0, rows: [] }
        // } else if ( apiParams.format == 'merged' ) {
        //   return await go.get('/multiproduct/cost-center/grid', newParams)
      } else {
        return await go.get('/multiproduct/cost-center/grid', newParams)
      }
    },

    async checkDownload() {
      const filter = this.$refs.report.apiParams
      const newParams = this.computeApiParams(filter)
      if (newParams.costCenterIds == null) {
        this.$info({
          message: `
            <p>Para baixar o arquivo Excel deste relatório,
            é necessário selecionar pelo menos um centro de
            custo.</p>
          `
        })
        // } else if ( newParams.format == 'merged' ) {
        //   const res = await go.download('/measure-v2/grid/download', newParams)
        //   saveBlobAs(res.blob, res.filename)
      } else {
        const res = await go.download(
          '/multiproduct/cost-center/grid/download',
          newParams
        )
        saveBlobAs(res.blob, res.filename)
      }
    }
  }
}
</script>

<style></style>
